import { render, staticRenderFns } from "./draggableFather.vue?vue&type=template&id=3526b3dc"
import script from "./draggableFather.vue?vue&type=script&lang=js"
export * from "./draggableFather.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports